import { Routes } from '@angular/router';
import { SCOPES } from 'src/app/app.constants';
import { ScopeGuard } from '../auth/services/scope.guard';

export const ACCOUNT_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./account.component').then((m) => m.AccountComponent),
    children: [
      {
        path: 'api-keys/new',
        loadComponent: () =>
          import('../api-keys/components/api-key-editor/api-key-editor.component').then((m) => m.ApiKeyEditorComponent),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.apiKeys.manage] },
      },
      {
        path: 'api-keys/:id',
        loadComponent: () =>
          import('../api-keys/components/api-key-editor/api-key-editor.component').then((m) => m.ApiKeyEditorComponent),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.apiKeys.manage] },
      },
      {
        path: 'api-keys',
        loadComponent: () =>
          import('../api-keys/components/api-key-list/api-key-list.component').then((m) => m.ApiKeyListComponent),
        canActivate: [ScopeGuard],
        data: { scopes: [SCOPES.apiKeys.manage] },
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./components/notifications/notifications.component').then((m) => m.NotificationsComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile.component').then((m) => m.ProfileComponent),
      },
      {
        path: 'security',
        loadComponent: () => import('./components/security/security.component').then((m) => m.SecurityComponent),
      },
      {
        path: 'settings',
        loadComponent: () => import('./components/settings/settings.component').then((m) => m.SettingsComponent),
      },
      { path: '**', redirectTo: 'profile' },
    ],
  },
];
